import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../image/logo.png";
import "./LandingStyleHeader.css";

const navItems = [
  { label: "About Us", path: "/about-us" },
  { label: "Services", path: "/services" },
  { label: "How It Works", path: "/how-it-works" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Contact", path: "/contact-us" },
];

const LandingStyleHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="landing-shared-nav">
      <div className="landing-shared-shell landing-shared-nav-inner">
        <button
          type="button"
          className="landing-shared-logo-button"
          onClick={() => navigate("/landing")}
          aria-label="Go to landing page"
        >
          <img src={logo} alt="TattQR logo" />
        </button>

        <nav className="landing-shared-links">
          {navItems.map((item) => (
            <button
              key={item.path}
              type="button"
              className="landing-shared-nav-link"
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="landing-shared-actions">
          <button
            type="button"
            className="landing-shared-login-btn"
            onClick={() => navigate("/login")}
          >
            Login
          </button>
          <button
            type="button"
            className="landing-shared-gold-btn"
            onClick={() => navigate("/signup")}
          >
            Design My QR
          </button>
        </div>
      </div>
    </header>
  );
};

export default LandingStyleHeader;
